
export const ticketData = [
  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Lost & Found",
    status: "Closed",
    priority: "Medium",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Service related",
    status: "Open",
    priority: "Low",
    recent_activity: "Moved to finance department",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Lost & Found",
    status: "Closed",
    priority: "Medium",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Service related",
    status: "Open",
    priority: "Low",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Lost & Found",
    status: "Closed",
    priority: "Medium",
    recent_activity: "Moved to finance department",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Service Related",
    status: "Open",
    priority: "Low",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Lost & Found",
    status: "Closed",
    priority: "Medium",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Service Related",
    status: "Open",
    priority: "Low",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Lost & Found",
    status: "Closed",
    priority: "Medium",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Lost & Found",
    status: "Closed",
    priority: "Medium",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Lost & Found",
    status: "Closed",
    priority: "Medium",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Lost & Found",
    status: "Closed",
    priority: "Medium",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",

    customer_name: "Ronaldo",
    subject: "Lost & Found",
    
    
    status: "Closed",
    priority: "Medium",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",

    customer_name: "Ronaldo",
    subject: "Lost & Found",
    
    
    status: "Closed",
    priority: "Medium",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Lost & Found",
    status: "Closed",
    priority: "Medium",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Lost & Found",
    status: "Closed",
    priority: "Medium",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },

  {
    booking_number: "689643875",
    ticket_number: "BNC922030082",
    customer_name: "Ronaldo",
    subject: "Lost & Found",
    status: "Closed",
    priority: "Medium",
    recent_activity: "Admin review pending",
    reported_on: "Sep 28,2022 12:30 PM",
  },
];

export const ticketColumns = [
  {
    name: "TICKET #",
    selector: (row) => row["ticket_number"],
    sortable: true,
    center: true,
  },
  {
    name: "CUSTOMER NAME",
    selector: (row) => row["customer_name"],
    sortable: true,
    center: true,
    minWidth: "132px"
  },
  {
    name: "BOOKING #",
    selector: (row) => row["booking_number"],
    sortable: true,
    center: true,
  },
  {
    name: "SUBJECT",
    selector: (row) => row["subject"],
    sortable: true,
    center: true,
  },
  {
    name: "STATUS",
    selector: (row) => row["status"],
    sortable: true,
    center: true,
  },
  {
    name: "PRIORITY",
    selector: (row) => row["priority"],
    sortable: true,
    center: true,
  },
  {
    name: "RECENT ACTIVITY",
    selector: (row) => row["recent_activity"],
    sortable: true,
    center: true,
  },
  {
    name: "REPORTED ON",
    selector: (row) => row["reported_on"],
    sortable: true,
    center: true,
  },
  {
    name: "",
    selector: (row) => row["action"],
    sortable: true,
    center: true,
    width:"70px"
  },
];
